import React from "react";
import styled from "styled-components";
import { X } from "lucide-react";

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 10000;
  opacity: ${props => props.isOpen ? 1 : 0};
  visibility: ${props => props.isOpen ? 'visible' : 'hidden'};
  transition: opacity 0.3s ease, visibility 0.3s ease;
  padding: 1rem;
`;

const ModalContent = styled.div`
  background-color: #FFFFFF;
  border-radius: 1rem;
  padding: 0;
  width: 100%;
  max-width: 450px;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.25);
  transform: ${props => props.isOpen ? 'scale(1)' : 'scale(0.95)'};
  transition: transform 0.3s ease;
  font-family: 'Prompt', sans-serif;
  position: relative;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 1rem;
  right: 1rem;
  background: none;
  border: none;
  cursor: pointer;
  color: #9CA3AF;
  padding: 0.5rem;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s;
  z-index: 1;

  &:hover {
    color: #6B7280;
    background-color: #F3F4F6;
  }

  svg {
    width: 1.25rem;
    height: 1.25rem;
  }
`;

const ModalHeader = styled.div`
  padding: 2rem 2rem 1rem 2rem;
  text-align: center;
`;

const ModalTitle = styled.h2`
  color: #000000;
  font-size: 1.25rem;
  font-weight: 400;
  margin: 0 0 1rem 0;
  text-align: left;
`;

const TitleDivider = styled.hr`
  border: none;
  border-top: 1px solid #ECECEC;
  margin: 0 -2rem 2rem -2rem;
  width: calc(100% + 4rem);
`;

const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  margin-bottom: 2rem;
`;

const HealthIcon = styled.img`
  width: 80px;
  height: 80px;
  object-fit: cover;
`;

const MessageContainer = styled.div`
  padding: 0 2rem 2rem 2rem;
  text-align: center;
`;

const MessageTitle = styled.h3`
  color: #171717;
  font-size: 18px;
  font-weight: 400;
  margin: 0 0 0.5rem 0;
`;

const MessageText = styled.p`
  color: #171717;
  font-size: 18px;
  font-weight: 400;
  margin: 0 0 2rem 0;
  line-height: 1;
`;

const ModalFooter = styled.div`
  padding: 0 2rem 2rem 2rem;
  display: flex;
  gap: 1rem;
  justify-content: center;
`;

const CancelButton = styled.button`
  background-color: #CFD3D4;
  color: #6F6F6F;
  border: solid 1px #CFD3D4;
  border-radius: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Prompt', sans-serif;

  &:hover {
    background-color: #CFD3D4;
  }
`;

const ConfirmButton = styled.button`
  background-color: #00B5B8;
  color: white;
  border: none;
  border-radius: 0.5rem;
  padding: 0.75rem 1.5rem;
  font-size: 14px;
  font-weight: 400;
  cursor: pointer;
  transition: all 0.2s;
  font-family: 'Prompt', sans-serif;

  &:hover {
    background-color: #00B5B8;
    transform: translateY(-1px);
  }
`;

const SendHealthResultModal = ({ isOpen, onClose, onConfirm }) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose && onClose();
    }
  };

  const handleConfirm = () => {
    onConfirm && onConfirm();
    onClose && onClose();
  };

  return (
    <ModalOverlay isOpen={isOpen} onClick={handleOverlayClick}>
      <ModalContent isOpen={isOpen}>
        <CloseButton onClick={onClose}>
          <X />
        </CloseButton>

        <ModalHeader>
          <ModalTitle>ต้องการส่งการแปลผลสุขภาพใหม่</ModalTitle>
          <TitleDivider />

          <IconContainer>
            <HealthIcon
              src="dataTransfer.png"
              alt="Health Icon"
            />
          </IconContainer>
        </ModalHeader>

        <MessageContainer>
          <MessageTitle>การส่งข้อมูลใหม่อีกครั้ง</MessageTitle>
          <MessageText>
            ข้อมูลสุขภาพเก่าจะถูกแทนด้วยข้อมูลสุขภาพใหม่
          </MessageText>
        </MessageContainer>

        <ModalFooter>
          <CancelButton onClick={onClose}>
            ยกเลิก
          </CancelButton>
          <ConfirmButton onClick={handleConfirm}>
            ยืนยัน
          </ConfirmButton>
        </ModalFooter>
      </ModalContent>
    </ModalOverlay>
  );
};

export default SendHealthResultModal;